<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box op_down modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_confirm_purchase_for_pin_title }}<br>
          {{ getTranslations.home_modals_confirm_purchase_for_pin_oups_something }}</h1>
        <img src="static/images/profile/profile-emptystate.png" class="op_down_img">
        <p>{{ getTranslations.home_modals_confirm_purchase_for_pin_bundles_are_currently }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// modal_operator_down_PIN
export default {
  name: 'confirm-purchase-for-pin-error',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseForPinError.vue